import type { IconData } from '@stacksjs/iconify-core'

export const basicUiNotifications: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 6a6 6 0 1 1 12 0v3.5l2 2H0l2-2zm9 7a3 3 0 1 1-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiNotifications
